import { render, staticRenderFns } from "./ResetAuthenticator.vue?vue&type=template&id=ca6debf8&"
import script from "./ResetAuthenticator.vue?vue&type=script&lang=js&"
export * from "./ResetAuthenticator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports